var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-textarea',_vm._g(_vm._b({},'b-form-textarea',{ ..._vm.$attrs, ..._vm.$props, value: _vm.innateValue },false),{
        ..._vm.$listeners,
        input: ($event) => (_vm.innateValue = $event),
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }